import { apiJsonRequest } from "./apiRequest";

// Resolves a mixed list (existing {id,name} tag objects + newly typed name
// strings) into real {id,name} tag records, creating any new ones on the
// server. `tags.json#create` is find-or-create by name, so this is also
// how a tag typed by one user gets reused instead of duplicated.
export const resolveTags = async (nextTags = [], existingTags = []) => {
  const resolved = await Promise.all(
    (nextTags || []).map(async (item) => {
      if (item && typeof item === "object" && item.id) return item;

      const name = typeof item === "string" ? item.trim() : `${item?.name ?? ""}`.trim();
      if (!name) return null;

      const existing = existingTags.find(
        (tag) => tag?.name?.toLowerCase() === name.toLowerCase()
      );
      if (existing) return existing;

      const { data: newTag } = await apiJsonRequest("tags.json", "POST", { name });
      return newTag?.id ? { id: newTag.id, name: newTag.name } : null;
    })
  );

  const seen = new Set();
  return resolved.filter((tag) => {
    if (!tag) return false;
    const key = tag.id != null ? `id:${tag.id}` : `name:${(tag.name || "").toLowerCase()}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

export default resolveTags;
